<template>
    <div class="banner20210315 flexstart">
        <div class="banner left">
            <el-carousel height="446px">
                <el-carousel-item v-for="(obj,i) in datalist" :key="i">
                    <div class="img-box" @click="goto(obj)">
                        <img class="img" v-lazy="obj.adurl" :alt="obj.adtitle" >
                        <div class="adtitle fs-20 tc-write">{{obj.adtitle}}</div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="right author-list">
            <div class="title icon_anthor fs-20 blod flex-start">推荐作者</div>
            <div class="box flex-start pointer" v-for="(obj,i) in authorlist" :key="i">
                <div class="left flex-start" @click="handleClick(obj)">
                    <div class="img-box"><img class="img" v-lazy="obj.logourl" alt=""></div>
                    <div class="text-box">
                        <div class="fs-16 tc-black subject">{{obj.hostname}}</div>
                        <div class="fs-14 tc-grey text-ellipse description">{{obj.description}}</div>
                    </div>
                </div>
                <div class="right">
                    <div class="btn fs-12 tc" :class="[obj.isfavorite==1?'':'active']" @click="handleFollow(obj)">{{obj.isfavorite==1?'已关注':'关注'}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {getAdConfig, getIndexRecommAuthor} from 'api/systemApi'
  import {uploadCourseHostFollow} from 'api/api'
  export default {
    name: 'banner20210315',
    data() {
      return {
        param: {
          adcode: 'N01'
        },
        datalist: [],
        authorlist: []
      }
    },
    mounted() {
      this._getList()
      this._getIndexRecommAuthor()
    },
    methods: {
      goto(obj) {
        window.open(obj.clickurl)
      },
      handleFollow(obj) {
        if (!this.user.isLogin) {
          this.setLoginPop(true)
          return
        }
        if (obj.isfavorite == 1) return false
        this.setLoading(true)
        uploadCourseHostFollow({
          data: {optype: 1, hostid: obj.hostinnerid},
          success: () => {
            obj.isfavorite = 1
            this.setLoading(false)
            this.$message.success('关注成功')
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      handleClick(obj) {
        this.$router.push({name: 'OrganIndex', query: {'hostid': obj.hostinnerid, 'tabs': '2'}})
      },
      _getList() {
        this.setLoading(true)
        getAdConfig({
          data: this.param,
          success: data=> {
            this.setLoading(false)
            this.datalist = data.data.content
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      _getIndexRecommAuthor() {
        this.setLoading(true)
        getIndexRecommAuthor({
          data: this.param,
          success: data=> {
            this.setLoading(false)
            this.authorlist = data.data.content
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setLoginPop'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['user'])
    },
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.banner20210315 {
    padding-top: 20px;
    width: 1200px;
    margin: auto;
    .banner{
        width: 792px;
        min-width: 792px;
        margin-right: 30px;
        .img-box{
            width: 792px;
            height: 446px;
            background: #1464C8;
            .img{
                width: 100%;
                height:100%;
                border-radius: 4px;
            }
            .adtitle{
                height: 80px;
                left: 0;
                right:0;
                position: absolute;
                bottom: 0;
                padding: 20px 20px;
                box-sizing: border-box;
                background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.40) 57%, rgba(0,0,0,0.80) 100%);
                border-radius: 0 0 4px 4px;
            }
        }
        .el-carousel__indicators--horizontal{
            left:0;
            bottom: 5px;
            transform: translateX(20px)
        }
    }
    .author-list{
        height: 446px;
        flex-grow: 1;
        .icon_anthor:before{
            width: 16px;
            height: 16px;
            margin-right: 10px;
        }
        .box{
            height: 88px;
            box-sizing: border-box;
            .subject{
                margin-bottom: 10px;
            }
        }
        .box+.box{
            border-top: 1px solid #EEEEEE;
        }
        .left{
            flex-grow: 1;
            .img-box{
                margin-right: 10px;
                width: 48px;
                min-width: 48px;
                height: 48px;
                border-radius: 50%;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .text-box{
                flex-grow: 1;
                .description{
                    width: 240px;
                }
            }
        }
        .right{
            margin-left: 20px;
            .btn{
                width: 58px;
                height: 24px;
                border-radius: 4px;
                background: #FFFFFF;
                color: #999999;
                border: 1px solid #CCCCCC;
                line-height: 24px;
                cursor: default;
            }
            .active{
                cursor: pointer;
                &:hover{
                    color: #409EFF;
                    border: 1px solid #409EFF;
                }
            }
        }
    }

}
</style>